// extracted by mini-css-extract-plugin
export default {"logo":"logo__CFlVC","heading":"heading__3kwiN","brandName":"brandName__2pFqY","caption":"caption__1eMU0"};